import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getImmunizationResultsPDF } from '../actions/api';
import printIcon from '../images/print-icon.png';

class PrintButton extends Component {
    onClickPDF =()=>{
        let userId= null;
        if(this.props.selectedUser.isDependent){
            userId = this.props.selectedUser.id;
        }

        this.props.dispatch(getImmunizationResultsPDF(userId))
    }
    render() {
        return (
            <div >
                <button class={"btn btn-success btn-lg btn-block"} onClick={() => this.onClickPDF()}>
                {/* <button class={"btn btn-light rounded-0"} onClick={() => window.print()}> */}
                    <img src={printIcon} width="18px"/>&nbsp;
                    {this.props.strings.PRINT_BUTTON}
                </button>
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        strings: state.language.strings,
        deviceType: state.api.deviceType,
        selectedUser: state.api.selectedUser,
    }
}

export default connect(mapStateToProps)(PrintButton)